import type { MenuProps } from 'antd';

export const menuItems: MenuProps['items'] = [
  { key: 'download', label: 'Скачать' },
  { key: 'edit', label: 'Редактировать' },
  { key: 'delete', label: 'Удалить' },
];
